/*
 * File: Order.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:  Model for viewing the list of orders so we can add/edit an existing
 * order without an API call
 */

import { types } from "mobx-state-tree";
import OrderViews from "../views/OrderViews";
import OrderNote from "./OrderNote";
import OrderActions from "../actions/OrderActions";

const DataModel = {
  assignedToUserId: types.maybe(types.number),
  due: types.maybeNull(types.Date),
  incidentId: types.maybe(types.number),
  longDescription: types.maybe(types.string),
  officeId: types.maybe(types.number),
  // ordered: types.maybe(types.string), This is returned by the API, but we're not displaying or allowing for updating it
  ordered: types.maybe(types.string),
  //orderNotes is the list of all notes for the order returned by API
  orderNotes: types.optional(types.array(OrderNote), []),
  //orderNote is the current note message to add to the order
  orderNote: types.maybe(types.string),
  ordersId: types.maybe(types.number),
  patientId: types.maybe(types.number),
  patientFirst: types.maybe(types.string),
  patientLast: types.maybe(types.string),
  providerId: types.maybe(types.number),
  resourceId: types.maybe(types.number),
  shortDescription: types.maybe(types.string),
  orderStatusId: types.optional(types.number, 1),
  typeId: types.optional(types.number, 100),
  urgent: types.optional(types.boolean, false)
};

let OrderModel = types
  .model("OrderModel", DataModel)
  .actions(OrderActions)
  .views(OrderViews);

export default OrderModel;
